// Scroll thresholds and constants
export const SCROLL_BOTTOM_THRESHOLD = 100; // px from bottom to consider "at bottom"
export const SCROLL_TOP_THRESHOLD = 100; // px from top to trigger load more
export const SCROLL_DEBOUNCE_MS = 100; // Debounce scroll events
export const MEDIA_PLACEHOLDER_HEIGHT = 200; // Reserved height for media loading
export const MEDIA_PLACEHOLDER_WIDTH = 280; // Reserved width for media loading

// Emoji categories
export const EMOJI_CATEGORIES = {
  recent: ['😊', '❤️', '😂', '🔥', '👍', '😍', '🥺', '✨'],
  smileys: ['😀', '😃', '😄', '😁', '😅', '😂', '🤣', '😊', '😇', '🙂', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '😋', '😛', '😜', '🤪', '😝', '🤑', '🤗', '🤭', '🤫', '🤔', '🤐', '🤨', '😐', '😑', '😶', '😏', '😒', '🙄', '😬', '🤥'],
  hearts: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟'],
  gestures: ['👍', '👎', '👊', '✊', '🤛', '🤜', '🤞', '✌️', '🤟', '🤘', '👌', '🤌', '🤏', '👈', '👉', '👆', '👇', '☝️', '✋', '🤚', '🖐️', '🖖', '👋', '🤙', '💪', '🦾', '🙏', '🤝', '💅'],
  animals: ['🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐻‍❄️', '🐨', '🐯', '🦁', '🐮', '🐷', '🐸', '🐵', '🙈', '🙉', '🙊', '🐔', '🐧', '🐦', '🦆', '🦅', '🦉', '🦇', '🐺', '🐗', '🐴', '🦄'],
  objects: ['🔥', '✨', '⭐', '🌟', '💫', '💥', '💢', '💦', '💨', '🎉', '🎊', '🎈', '🎁', '🏆', '🥇', '🎯', '💎', '💰', '💵', '📱', '💻', '⌚', '📷', '🎬', '🎤', '🎧', '🎮', '🚗', '✈️', '🚀'],
};

// Reaction emojis
export const REACTION_EMOJIS = ['❤️', '😂', '😮', '😢', '😡', '👍'];

// Timer display helper (chat-level only - no "view" option)
export const getTimerDisplay = (timer) => {
  const map = { "24h": "24 hours", "7d": "7 days", "30d": "30 days", "off": "off" };
  return map[timer] || timer;
};

// Format last seen time
export const formatLastSeen = (lastSeenStr) => {
  if (!lastSeenStr) return '';
  
  const lastSeen = new Date(lastSeenStr);
  const now = new Date();
  const diffMs = now - lastSeen;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays === 1) return 'yesterday';
  if (diffDays < 7) return `${diffDays}d ago`;
  
  return lastSeen.toLocaleDateString([], { month: 'short', day: 'numeric' });
};

// Format date separator for chat
export const formatDateSeparator = (dateStr) => {
  if (!dateStr) return '';
  
  const date = new Date(dateStr);
  const now = new Date();
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  
  if (date.toDateString() === now.toDateString()) {
    return 'Today';
  } else if (date.toDateString() === yesterday.toDateString()) {
    return 'Yesterday';
  } else if (now.getTime() - date.getTime() < 7 * 24 * 60 * 60 * 1000) {
    return date.toLocaleDateString([], { weekday: 'long' });
  } else {
    return date.toLocaleDateString([], { month: 'short', day: 'numeric', year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined });
  }
};
